import { getDimension } from './catalog.js';
import { firstOfMonth, firstOfYear, isRealDate, lastOfMonth, lastOfYear } from './dates.js';
const TIME_CHILD = { year: 'month', month: 'day', day: 'hour' };
export function drillDown(request, target) {
    const dim = getDimension(target.dimension);
    if (dim === undefined || !(request.dimensions ?? []).includes(target.dimension) && request.granularity !== target.dimension) {
        return { ok: false, code: 'DRILL_DIMENSION_NOT_IN_QUERY', field: target.dimension };
    }
    const child = dim.hierarchy?.child;
    if (child === undefined)
        return { ok: false, code: 'DRILL_AT_LEAF', field: target.dimension };
    // ---- time: narrow the period to the clicked bucket and go one grain finer ----
    if (dim.hierarchy?.chain === 'time') {
        let from;
        let to;
        if (target.dimension === 'year' && /^\d{4}$/.test(target.key)) {
            from = firstOfYear(`${target.key}-01-01`);
            to = lastOfYear(`${target.key}-01-01`);
        }
        else if (target.dimension === 'month' && /^\d{4}-\d{2}$/.test(target.key) && isRealDate(`${target.key}-01`)) {
            from = firstOfMonth(`${target.key}-01`);
            to = lastOfMonth(`${target.key}-01`);
        }
        else if (target.dimension === 'day' && isRealDate(target.key)) {
            from = target.key;
            to = target.key;
        }
        else {
            return { ok: false, code: 'DRILL_KEY_INVALID', field: target.dimension };
        }
        const current = 'relative' in request.period ? undefined : request.period;
        // Never widen: the drilled period stays inside the period that was asked.
        const clampedFrom = current !== undefined && current.from > from ? current.from : from;
        const clampedTo = current !== undefined && current.to < to ? current.to : to;
        if (clampedFrom > clampedTo)
            return { ok: false, code: 'DRILL_KEY_INVALID', field: target.dimension };
        const rest = (request.dimensions ?? []).filter((d) => getDimension(d)?.hierarchy?.chain !== 'time');
        return {
            ok: true,
            value: { ...request, dimensions: rest, granularity: TIME_CHILD[target.dimension], period: { from: clampedFrom, to: clampedTo } },
        };
    }
    // ---- everything else: filter to the clicked key and swap the dimension for its child ----
    const filters = [...(request.filters ?? []).filter((f) => f.dimension !== target.dimension && !(target.marketId !== undefined && f.dimension === 'market'))];
    filters.push({ dimension: target.dimension, op: 'eq', values: [target.key] });
    if (target.marketId !== undefined && target.dimension !== 'market')
        filters.push({ dimension: 'market', op: 'eq', values: [target.marketId] });
    const dimensions = (request.dimensions ?? []).map((d) => (d === target.dimension ? child : d));
    return { ok: true, value: { ...request, dimensions: [...new Set(dimensions)], filters } };
}
//# sourceMappingURL=drill.js.map